module.exports = __webpack_public_path__ + "static/assets/9888ffb13ae44db572e596ef50dfd2f2.svg";